import { useImperativeHandle, useRef } from "react";

import { Counter, Flex, isNullish, Text } from "@theorgchartdev/storybook";
import ToolbarPopover from "@/appComponents/Navigation/ContextualToolbar/ToolbarPopover/ToolbarPopover";

export const ObjectSpacingPopover = props => {
  const value = props.value[props.updateKey];
  const popoverOpenCtrlRef = useRef(null);

  useImperativeHandle(props.openCtrlRef, () => popoverOpenCtrlRef.current);

  const handleSpacingChange = newSpacingSize => {
    const nextValue = { ...props.value };
    nextValue[props.updateKey] = newSpacingSize;
    props.onChange(nextValue);
  };

  const currentSpacing = !isNullish(value) ? parseFloat(value) : 0;

  const tooltipProps = structuredClone(props.toolbarPopoverProps?.iconProps?.tooltipProps);
  if (!isNullish(tooltipProps)) {
    tooltipProps.referenceOpenCtrlRef = popoverOpenCtrlRef;
  }

  return (
    <ToolbarPopover
      icon={props.icon}
      key={props.icon}
      triggerTestId={props.triggerTestId}
      iconProps={{ ...props.toolbarPopoverProps?.iconProps, tooltipProps: tooltipProps }}
      otherPopoverProps={{
        openCtrlRef: popoverOpenCtrlRef
      }}
    >
      <Flex direction="column" gap="12px">
        <Text modifier="medium" size="small">
          {props.title}
        </Text>
        <Counter
          key={6}
          onChange={handleSpacingChange}
          handle
          callbackOnInputChange={true}
          currentValue={currentSpacing}
          defaultValue={currentSpacing}
          inputStyles={{ width: "60px" }}
          minValue={0}
          maxValue={50}
          size={"small"}
        />
      </Flex>
    </ToolbarPopover>
  );
};
